import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Heading,
    HStack,
    VStack,
    Input,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    useDisclosure,
    useToast,
    IconButton,
    Tooltip,
    Text,
    Flex,
    useColorMode,
    Card,
    CardBody,
    CardHeader,
    CardFooter,
    Badge,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Code,
    Skeleton,
    SkeletonText,
    useClipboard,
    FormControl,
    FormLabel,
    FormHelperText,
    FormErrorMessage,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Divider,
    Stat,
    StatLabel,
    StatNumber,
    StatHelpText,
    StatArrow,
    Grid,
    GridItem,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    useBreakpointValue,
    Progress,
    Switch,
    Select,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Stack,
    Avatar,
    AvatarGroup,
    Wrap,
    WrapItem,
    Tag,
    TagLabel,
    TagLeftIcon,
    TagRightIcon,
    TagCloseButton,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    DrawerFooter,
    DrawerCloseButton,
} from '@chakra-ui/react';
import {
    MdVpnKey,
    MdDelete,
    MdEdit,
    MdRefresh,
    MdContentCopy,
    MdVisibility,
    MdVisibilityOff,
    MdMoreVert,
    MdSecurity,
    MdWarning,
    MdInfo,
    MdLock,
    MdLockOpen,
    MdAccessTime,
    MdCalendarToday,
    MdHistory,
    MdSettings,
    MdFilterList,
    MdSearch,
    MdClear,
    MdDownload,
    MdUpload,
    MdCheckCircle,
    MdError,
    MdHelp,
    MdQuestionMark,
    MdStar,
    MdStarBorder,
    MdStarHalf,
    MdFavorite,
    MdFavoriteBorder,
    MdThumbUp,
    MdThumbDown,
    MdThumbUpOffAlt,
    MdThumbDownOffAlt,
    MdShare,
    MdLink,
    MdOpenInNew,
    MdClose,
    MdCheck,
    MdCancel,
    MdAdd,
    MdRemove,
    MdExpandMore,
    MdExpandLess,
    MdChevronRight,
    MdChevronLeft,
    MdArrowBack,
    MdArrowForward,
    MdArrowUpward,
    MdArrowDownward,
    MdArrowBackIos,
    MdArrowForwardIos,
    MdArrowUpwardIos,
    MdArrowDownwardIos,
    MdArrowDropDown,
    MdArrowDropUp,
    MdArrowDropDownCircle,
    MdArrowDropUpCircle,
    MdArrowRight,
    MdArrowLeft,
    MdArrowUp,
    MdArrowDown
} from 'react-icons/md';
import { FiPlus } from 'react-icons/fi';
import { Helmet } from "react-helmet";
import Navigation from '../components/Navigation';
import axios from '../utils/axiosConfig';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
    Filler
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    ChartTooltip,
    Legend,
    Filler
);

const ApiKeyManagement = () => {
    const { colorMode } = useColorMode();
    const [apiKeys, setApiKeys] = useState([]);
    const [keyName, setKeyName] = useState('');
    const [newKey, setNewKey] = useState(null);
    const [editingKey, setEditingKey] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showKey, setShowKey] = useState(false);
    const [stats, setStats] = useState({
        totalKeys: 0,
        activeKeys: 0,
        revokedKeys: 0,
        lastGenerated: null,
        usageStats: {
            totalRequests: 0,
            successfulRequests: 0,
            failedRequests: 0,
            averageResponseTime: 0,
            dailyUsage: [],
            weeklyUsage: [],
            monthlyUsage: []
        }
    });
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isRenameOpen, onOpen: onRenameOpen, onClose: onRenameClose } = useDisclosure();
    const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
    const { isOpen: isSecurityOpen, onOpen: onSecurityOpen, onClose: onSecurityClose } = useDisclosure();
    const { isOpen: isDetailsOpen, onOpen: onDetailsOpen, onClose: onDetailsClose } = useDisclosure();
    const [keyToDelete, setKeyToDelete] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });
    const [activeTab, setActiveTab] = useState(0);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [selectedKey, setSelectedKey] = useState(null);
    const [securitySettings, setSecuritySettings] = useState({
        ipRestrictions: [],
        rateLimiting: {
            enabled: false,
            requestsPerMinute: 60
        },
        permissions: {
            read: true,
            write: false,
            admin: false
        }
    });
    const toast = useToast();
    const { hasCopied, onCopy } = useClipboard(newKey?.key || '');
    const isMobile = useBreakpointValue({ base: true, md: false });

    useEffect(() => {
        fetchApiKeys();
        fetchStats();
    }, []);

    const fetchApiKeys = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/api/protected/api-keys');
            setApiKeys(response.data.data);
        } catch (error) {
            console.error('Error fetching API keys:', error);
            toast({
                title: 'Error',
                description: 'Unable to fetch API keys.',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchStats = async () => {
        try {
            const response = await axios.get('/api/protected/api-keys/stats');
            setStats(prev => ({
                ...prev,
                ...response.data,
                usageStats: {
                    ...prev.usageStats,
                    ...(response.data.usageStats || {})
                }
            }));
        } catch (error) {
            console.error('Error fetching stats:', error);
            // Keep the default stats structure even if fetch fails
            setStats(prev => ({
                ...prev,
                usageStats: {
                    ...prev.usageStats
                }
            }));
        }
    };

    const resetModalState = () => {
        setKeyName('');
        setNewKey(null);
        setShowKey(false);
    };

    const generateApiKey = async () => {
        if (!keyName.trim()) {
            toast({
                title: 'Error',
                description: 'Please enter a name for the API key.',
                status: 'error',
                duration: 3000,
                isClosable: true
            });
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post('/api/protected/generate-key', { name: keyName });

            if (!response.data?.success) {
                throw new Error(response.data?.message || 'Failed to generate API key');
            }

            // The API returns the key in response.data.key
            const { key: apiKey, maskedKey, createdAt } = response.data.data;


            // Update the API keys list with the masked version
            setApiKeys((prevKeys) => [...prevKeys, {
                _id: apiKey, // Using the key as ID since it's unique
                name: keyName,
                maskedKey: maskedKey, // Use maskedKey for display
                createdAt: createdAt
            }]);

            // Store the full key temporarily for display
            setNewKey({
                id: apiKey,
                key: apiKey, // This is the full key that needs to be copied
                maskedKey,
                createdAt: new Date().toISOString()
            });

            setStats(prev => ({
                ...prev,
                totalKeys: prev.totalKeys + 1,
                activeKeys: prev.activeKeys + 1,
                lastGenerated: new Date().toISOString()
            }));

            // Show success message with the key
            toast({
                title: 'API Key Generated',
                description: 'Please copy your API key now. You won\'t be able to see it again.',
                status: 'success',
                duration: 5000,
                isClosable: true
            });

            // Don't close the modal yet - let user copy the key
            setShowKey(true);
        } catch (error) {
            console.error('Error generating API key:', error);
            toast({
                title: 'Error',
                description: error.response?.data?.message || error.message || 'Failed to generate API key',
                status: 'error',
                duration: 3000,
                isClosable: true
            });
            // Don't close modal on error
            return;
        } finally {
            setLoading(false);
        }
    };

    const revokeApiKey = async (id) => {
        setLoading(true);
        try {
            await axios.delete(`/api/protected/api-keys/${id}`);
            setApiKeys((prevKeys) => prevKeys.filter((k) => k._id !== id));
            setStats(prev => ({
                ...prev,
                activeKeys: prev.activeKeys - 1,
                revokedKeys: prev.revokedKeys + 1
            }));
            toast({
                title: 'API Key Revoked',
                description: 'The API key has been successfully revoked.',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } catch (error) {
            console.error('Error revoking API key:', error);
            toast({
                title: 'Error',
                description: 'Unable to revoke API key.',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
            onDeleteClose();
        }
    };

    const handleRename = async (id) => {
        if (!keyName.trim()) {
            toast({
                title: 'Error',
                description: 'Please enter a name for the API key.',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
            return;
        }

        setLoading(true);
        try {
            const response = await axios.put(`/api/protected/api-keys/${id}`, { name: keyName });
            const updatedKey = response.data.data;
            setApiKeys((prevKeys) =>
                prevKeys.map((k) => (k._id === id ? { ...k, name: keyName } : k))
            );
            toast({
                title: 'API Key Renamed',
                description: 'The key has been successfully renamed.',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
            onRenameClose();
            setKeyName('');
        } catch (error) {
            console.error('Error renaming API key:', error);
            toast({
                title: 'Error',
                description: 'Unable to rename API key.',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Never';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        // Implement search logic
    };

    const handleFilterChange = (type, value) => {
        // Implement filter change logic
    };

    const handleExport = async () => {
        setIsExporting(true);
        try {
            // Implement export logic
            toast({
                title: 'Success',
                description: 'API keys exported successfully',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } catch (error) {
            console.error('Error exporting API keys:', error);
            toast({
                title: 'Error',
                description: 'Failed to export API keys',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setIsExporting(false);
        }
    };

    const handleSecuritySettings = async (keyId, settings) => {
        setLoading(true);
        try {
            await axios.put(`/api/protected/api-keys/${keyId}/security`, settings);
            toast({
                title: 'Success',
                description: 'Security settings updated successfully',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } catch (error) {
            console.error('Error updating security settings:', error);
            toast({
                title: 'Error',
                description: 'Failed to update security settings',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
            onSecurityClose();
        }
    };

    const handleCopyKey = (key) => {
        navigator.clipboard.writeText(key);
        toast({
            title: 'Copied',
            description: 'API key copied to clipboard',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
        });
    };

    const handleToggleActive = async (keyId, active) => {
        setLoading(true);
        try {
            await axios.put(`/api/protected/api-keys/${keyId}/status`, { active });
            setApiKeys((prevKeys) =>
                prevKeys.map((k) => (k._id === keyId ? { ...k, active } : k))
            );
            toast({
                title: 'Success',
                description: `API key ${active ? 'activated' : 'deactivated'} successfully`,
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        } catch (error) {
            console.error('Error toggling API key status:', error);
            toast({
                title: 'Error',
                description: 'Failed to update API key status',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteKey = (key) => {
        setKeyToDelete({
            _id: key._id,
            name: key.name
        });
        onDeleteOpen();
    };

    return (
        <>
            <Helmet>
                <title>API Keys | AI Call System</title>
                <meta name="description" content="Manage your API keys and access settings" />
            </Helmet>

            <Flex minH="100vh" bg={colorMode === 'light' ? 'gray.50' : 'gray.900'}>
                <Navigation />

                <Box flex="1" p={6} maxW="100%" overflowX="hidden">
                    <Flex justify="space-between" align="center" mb={6} flexWrap="wrap" gap={4}>
                        <Heading
                            size="lg"
                            color={colorMode === 'light' ? 'gray.800' : 'white'}
                        >
                            API Keys
                        </Heading>
                        <Flex gap={2}>
                            <Tooltip label="Refresh API keys">
                                <IconButton
                                    icon={<MdRefresh />}
                                    aria-label="Refresh API keys"
                                    onClick={() => {
                                        fetchApiKeys();
                                        fetchStats();
                                    }}
                                    colorScheme="brand"
                                    isLoading={loading}
                                />
                            </Tooltip>
                            <Button
                                leftIcon={<FiPlus />}
                                colorScheme="brand"
                                onClick={onOpen}
                                size="sm"
                            >
                                Create API Key
                            </Button>
                        </Flex>
                    </Flex>

                    {/* Stats Cards */}
                    {/* <Grid templateColumns={{ base: '1fr', md: 'repeat(4, 1fr)' }} gap={4} mb={6}>
                        <GridItem key="total-keys">
                            <Card bg={colorMode === 'light' ? 'white' : 'gray.800'}>
                                <CardBody>
                                    <Stat>
                                        <StatLabel>Total Keys</StatLabel>
                                        <StatNumber>{stats.totalKeys}</StatNumber>
                                        <StatHelpText>All time</StatHelpText>
                                    </Stat>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem key="active-keys">
                            <Card bg={colorMode === 'light' ? 'white' : 'gray.800'}>
                                <CardBody>
                                    <Stat>
                                        <StatLabel>Active Keys</StatLabel>
                                        <StatNumber>{stats.activeKeys}</StatNumber>
                                        <StatHelpText>Currently in use</StatHelpText>
                                    </Stat>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem key="success-rate">
                            <Card bg={colorMode === 'light' ? 'white' : 'gray.800'}>
                                <CardBody>
                                    <Stat>
                                        <StatLabel>Success Rate</StatLabel>
                                        <StatNumber>
                                            {stats.usageStats.totalRequests > 0
                                                ? ((stats.usageStats.successfulRequests / stats.usageStats.totalRequests) * 100).toFixed(1)
                                                : 0}%
                                        </StatNumber>
                                        <StatHelpText>API requests</StatHelpText>
                                    </Stat>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem key="response-time">
                            <Card bg={colorMode === 'light' ? 'white' : 'gray.800'}>
                                <CardBody>
                                    <Stat>
                                        <StatLabel>Avg Response Time</StatLabel>
                                        <StatNumber>{stats.usageStats.averageResponseTime}ms</StatNumber>
                                        <StatHelpText>Last 24 hours</StatHelpText>
                                    </Stat>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid> */}

                    {/* Usage Chart */}
                    {/* <Card bg={colorMode === 'light' ? 'white' : 'gray.800'} mb={6}>
                        <CardHeader>
                            <Heading size="md">API Usage</Heading>
                        </CardHeader>
                        <CardBody>
                            <Box h="300px">
                                <Line
                                    data={{
                                        labels: stats.usageStats.dailyUsage.map(day => formatDate(day.date)),
                                        datasets: [
                                            {
                                                label: 'Requests',
                                                data: stats.usageStats.dailyUsage.map(day => day.requests),
                                                borderColor: 'var(--chakra-colors-brand-500)',
                                                backgroundColor: 'var(--chakra-colors-brand-100)',
                                                tension: 0.1,
                                                fill: true
                                            }
                                        ]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'Daily API Requests'
                                            }
                                        },
                                        scales: {
                                            y: {
                                                beginAtZero: true
                                            }
                                        }
                                    }}
                                />
                            </Box>
                        </CardBody>
                    </Card> */}

                    {/* API Keys Table */}
                    <Card
                        bg={colorMode === 'light' ? 'white' : 'gray.800'}
                        borderRadius="lg"
                        boxShadow="sm"
                    >
                        <CardBody>
                            <Heading size="md" mb={4}>API Keys</Heading>

                            {loading ? (
                                <VStack spacing={4}>
                                    {Array(3).fill(0).map((_, i) => (
                                        <Skeleton key={i} height="60px" width="full" borderRadius="md" />
                                    ))}
                                </VStack>
                            ) : apiKeys.length > 0 ? (
                                <Table variant="simple">
                                    <Thead>
                                        <Tr>
                                            <Th color={colorMode === 'light' ? 'gray.600' : 'gray.100'}>Name</Th>
                                            <Th color={colorMode === 'light' ? 'gray.600' : 'gray.100'}>API Key</Th>
                                            <Th color={colorMode === 'light' ? 'gray.600' : 'gray.100'}>Created</Th>
                                            <Th color={colorMode === 'light' ? 'gray.600' : 'gray.100'}>Last Used</Th>
                                            <Th color={colorMode === 'light' ? 'gray.600' : 'gray.100'}>Actions</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {apiKeys.map((key) => (
                                            <Tr key={key._id}>
                                                <Td>
                                                    <Flex align="center" gap={2}>
                                                        <Text color={colorMode === 'light' ? 'gray.800' : 'white'}>{key.name}</Text>
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Text
                                                        color={colorMode === 'light' ? 'gray.800' : 'white'}
                                                        fontFamily="mono"
                                                    >
                                                        {key.maskedKey}
                                                    </Text>
                                                </Td>
                                                <Td color={colorMode === 'light' ? 'gray.800' : 'white'}>
                                                    {new Date(key.createdAt).toLocaleDateString()}
                                                </Td>
                                                <Td color={colorMode === 'light' ? 'gray.800' : 'white'}>
                                                    {key.lastUsed ? new Date(key.lastUsed).toLocaleDateString() : 'Never'}
                                                </Td>
                                                <Td>
                                                    <Tooltip label="Delete API Key">
                                                        <IconButton
                                                            icon={<MdDelete />}
                                                            aria-label="Delete API Key"
                                                            size="sm"
                                                            onClick={() => handleDeleteKey(key)}
                                                            colorScheme="red"
                                                        />
                                                    </Tooltip>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            ) : (
                                <Alert status="info" borderRadius="lg">
                                    <AlertIcon />
                                    <Text>No API keys created yet. Create a new key to get started.</Text>
                                </Alert>
                            )}
                        </CardBody>
                    </Card>

                    {/* Generate API Key Modal */}
                    <Modal isOpen={isOpen} onClose={() => {
                        onClose();
                        resetModalState();
                    }} closeOnOverlayClick={false}>
                        <ModalOverlay />
                        <ModalContent bg={colorMode === 'light' ? 'white' : 'gray.800'}>
                            <ModalHeader color={colorMode === 'light' ? 'gray.800' : 'white'}>
                                {newKey ? 'Copy Your API Key' : 'Generate New API Key'}
                            </ModalHeader>
                            <ModalCloseButton color={colorMode === 'light' ? 'gray.800' : 'white'} />
                            <ModalBody>
                                {newKey ? (
                                    <VStack spacing={4} align="stretch">
                                        <Alert status="warning" variant="left-accent">
                                            <AlertIcon />
                                            <Box>
                                                <AlertTitle>Important!</AlertTitle>
                                                <AlertDescription>
                                                    Copy your API key now. You won't be able to see it again!
                                                </AlertDescription>
                                            </Box>
                                        </Alert>
                                        <FormControl>
                                            <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.100'}>Your API Key</FormLabel>
                                            <InputGroup>
                                                <Input
                                                    value={newKey.key}
                                                    isReadOnly
                                                    bg={colorMode === 'light' ? 'gray.50' : 'gray.700'}
                                                    color={colorMode === 'light' ? 'gray.800' : 'white'}
                                                />
                                                <InputRightElement width="4.5rem">
                                                    <Button size="sm" onClick={() => handleCopyKey(newKey.key)}>
                                                        Copy
                                                    </Button>
                                                </InputRightElement>
                                            </InputGroup>
                                        </FormControl>
                                    </VStack>
                                ) : (
                                    <FormControl>
                                        <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.100'}>Key Name</FormLabel>
                                        <Input
                                            placeholder="Enter a name for this API key"
                                            value={keyName}
                                            onChange={(e) => setKeyName(e.target.value)}
                                            bg={colorMode === 'light' ? 'white' : 'gray.700'}
                                            color={colorMode === 'light' ? 'gray.800' : 'white'}
                                            borderColor={colorMode === 'light' ? 'gray.200' : 'gray.600'}
                                            _hover={{
                                                borderColor: colorMode === 'light' ? 'gray.300' : 'gray.500'
                                            }}
                                            _focus={{
                                                borderColor: 'brand.500',
                                                boxShadow: 'var(--chakra-shadows-outline)'
                                            }}
                                        />
                                    </FormControl>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                {newKey ? (
                                    <Button colorScheme="brand" onClick={() => {
                                        onClose();
                                        resetModalState();
                                    }}>
                                        Done
                                    </Button>
                                ) : (
                                    <>
                                        <Button variant="ghost" mr={3} onClick={() => {
                                            onClose();
                                            resetModalState();
                                        }}>
                                            Cancel
                                        </Button>
                                        <Button colorScheme="brand" onClick={generateApiKey} isLoading={loading}>
                                            Generate
                                        </Button>
                                    </>
                                )}
                            </ModalFooter>
                        </ModalContent>
                    </Modal>

                    {/* Security Settings Modal */}
                    <Modal isOpen={isSecurityOpen} onClose={onSecurityClose} size="xl">
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Security Settings</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <Stack spacing={4}>
                                    <FormControl>
                                        <FormLabel>IP Restrictions</FormLabel>
                                        <InputGroup>
                                            <Input
                                                placeholder="Enter IP address"
                                                value={securitySettings.ipRestrictions[0] || ''}
                                                onChange={(e) => setSecuritySettings(prev => ({
                                                    ...prev,
                                                    ipRestrictions: [e.target.value]
                                                }))}
                                            />
                                            <InputRightElement>
                                                <IconButton
                                                    icon={<MdAdd />}
                                                    aria-label="Add IP"
                                                    variant="ghost"
                                                />
                                            </InputRightElement>
                                        </InputGroup>
                                        <FormHelperText>
                                            Restrict API access to specific IP addresses
                                        </FormHelperText>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Rate Limiting</FormLabel>
                                        <Switch
                                            isChecked={securitySettings.rateLimiting.enabled}
                                            onChange={(e) => setSecuritySettings(prev => ({
                                                ...prev,
                                                rateLimiting: {
                                                    ...prev.rateLimiting,
                                                    enabled: e.target.checked
                                                }
                                            }))}
                                        >
                                            Enable Rate Limiting
                                        </Switch>
                                        {securitySettings.rateLimiting.enabled && (
                                            <NumberInput
                                                value={securitySettings.rateLimiting.requestsPerMinute}
                                                onChange={(value) => setSecuritySettings(prev => ({
                                                    ...prev,
                                                    rateLimiting: {
                                                        ...prev.rateLimiting,
                                                        requestsPerMinute: value
                                                    }
                                                }))}
                                                min={1}
                                                max={1000}
                                            >
                                                <NumberInputField />
                                                <NumberInputStepper>
                                                    <NumberIncrementStepper />
                                                    <NumberDecrementStepper />
                                                </NumberInputStepper>
                                            </NumberInput>
                                        )}
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Permissions</FormLabel>
                                        <VStack align="stretch">
                                            <HStack>
                                                <Switch
                                                    isChecked={securitySettings.permissions.read}
                                                    onChange={(e) => setSecuritySettings(prev => ({
                                                        ...prev,
                                                        permissions: {
                                                            ...prev.permissions,
                                                            read: e.target.checked
                                                        }
                                                    }))}
                                                >
                                                    Read Access
                                                </Switch>
                                            </HStack>
                                            <HStack>
                                                <Switch
                                                    isChecked={securitySettings.permissions.write}
                                                    onChange={(e) => setSecuritySettings(prev => ({
                                                        ...prev,
                                                        permissions: {
                                                            ...prev.permissions,
                                                            write: e.target.checked
                                                        }
                                                    }))}
                                                >
                                                    Write Access
                                                </Switch>
                                            </HStack>
                                            <HStack>
                                                <Switch
                                                    isChecked={securitySettings.permissions.admin}
                                                    onChange={(e) => setSecuritySettings(prev => ({
                                                        ...prev,
                                                        permissions: {
                                                            ...prev.permissions,
                                                            admin: e.target.checked
                                                        }
                                                    }))}
                                                >
                                                    Admin Access
                                                </Switch>
                                            </HStack>
                                        </VStack>
                                    </FormControl>
                                </Stack>
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="ghost" mr={3} onClick={onSecurityClose}>
                                    Close
                                </Button>
                                <Button
                                    colorScheme="brand"
                                    onClick={() => handleSecuritySettings(selectedKey._id, securitySettings)}
                                    isLoading={loading}
                                >
                                    Save Settings
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>

                    {/* Key Details Modal */}
                    <Modal isOpen={isDetailsOpen} onClose={onDetailsClose} size="xl">
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>API Key Details</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                {selectedKey && (
                                    <Stack spacing={4}>
                                        <FormControl>
                                            <FormLabel>Name</FormLabel>
                                            <Text>{selectedKey.name}</Text>
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Created</FormLabel>
                                            <Text>{formatDate(selectedKey.createdAt)}</Text>
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Last Used</FormLabel>
                                            <Text>{selectedKey.lastUsed ? formatDate(selectedKey.lastUsed) : 'Never'}</Text>
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Status</FormLabel>
                                            <Badge
                                                colorScheme="brand"
                                                variant={selectedKey.active ? "solid" : "subtle"}
                                            >
                                                {selectedKey.active ? 'Active' : 'Inactive'}
                                            </Badge>
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Usage Statistics</FormLabel>
                                            <VStack align="stretch" spacing={2}>
                                                <HStack justify="space-between">
                                                    <Text>Total Requests</Text>
                                                    <Text fontWeight="bold">{selectedKey.usageStats?.totalRequests || 0}</Text>
                                                </HStack>
                                                <HStack justify="space-between">
                                                    <Text>Successful Requests</Text>
                                                    <Text fontWeight="bold">{selectedKey.usageStats?.successfulRequests || 0}</Text>
                                                </HStack>
                                                <HStack justify="space-between">
                                                    <Text>Failed Requests</Text>
                                                    <Text fontWeight="bold">{selectedKey.usageStats?.failedRequests || 0}</Text>
                                                </HStack>
                                                <HStack justify="space-between">
                                                    <Text>Average Response Time</Text>
                                                    <Text fontWeight="bold">{selectedKey.usageStats?.averageResponseTime || 0}ms</Text>
                                                </HStack>
                                            </VStack>
                                        </FormControl>
                                    </Stack>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="ghost" mr={3} onClick={onDetailsClose}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>

                    {/* Delete Confirmation Modal */}
                    <Modal isOpen={isDeleteOpen} onClose={onDeleteClose}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Revoke API Key</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <Alert status="error" mb={4}>
                                    <AlertIcon />
                                    <Box>
                                        <AlertTitle>Warning!</AlertTitle>
                                        <AlertDescription>
                                            This action cannot be undone. The API key will be permanently revoked.
                                        </AlertDescription>
                                    </Box>
                                </Alert>
                                <Text>
                                    Are you sure you want to revoke the API key "{keyToDelete?.name}"? This will immediately invalidate the key and any applications using it will stop working.
                                </Text>
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="ghost" mr={3} onClick={onDeleteClose}>
                                    Cancel
                                </Button>
                                <Button
                                    colorScheme="red"
                                    onClick={() => revokeApiKey(keyToDelete?._id)}
                                    isLoading={loading}
                                >
                                    Revoke Key
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>

                    {/* Rename Modal */}
                    <Modal isOpen={isRenameOpen} onClose={onRenameClose}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Rename API Key</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <FormControl>
                                    <FormLabel>New Name</FormLabel>
                                    <Input
                                        value={keyName}
                                        onChange={(e) => setKeyName(e.target.value)}
                                        placeholder="Enter new name"
                                    />
                                </FormControl>
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="ghost" mr={3} onClick={onRenameClose}>
                                    Cancel
                                </Button>
                                <Button
                                    colorScheme="brand"
                                    onClick={() => handleRename(editingKey?._id)}
                                    isLoading={loading}
                                >
                                    Rename
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>
                </Box>
            </Flex>
        </>
    );
};

export default ApiKeyManagement;